import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import fotoMapa from "../../../../../img/fotoMapa.png";
import FooterAutorizacionVD from "../../../../../img/Footer_AutorizacionVD.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionVDListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "AUTORIZACIÓN AL PROCESO DE VISITA DIGITAL DOMICILIARIA";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    console.log("queryFecha.data:", queryFecha.data);

    if (queryFecha.data && queryFecha.data.length > 0) {
      const fechaAutorizacion = queryFecha.data[0].fecha_autorizacionvd || "";
      setValue("fecha_autorizacionvd", fechaAutorizacion);
    }
  }, [queryFecha.data, setValue]);

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        {/* Header */}
        <Header titulo={tituloFormulario} />

        {/* Contenido del formulario */}
        <div className="p-6">
          <div className="text-center mb-8">
            <div className="flex justify-left items-center gap-2 mb-4">
              <p className={`mt-3 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>Ciudad de México a</p>
              <Controller
                name="fecha_autorizacionvd"
                control={control}
                defaultValue={queryFecha.data?.[0]?.fecha_autorizacionvd || ""}
                render={({ field }) => (
                  <TextInput
                    id="fecha_autorizacionvd"
                    type="date"
                    value={field.value}
                    disabled
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                    className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
                  />
                )}
              />
            </div>
            <h2 className={`text-xl font-bold mb-4 ${isDarkMode ? "text-white" : "text-gray-900"}`}>
              AUTORIZACIÓN AL PROCESO DE VISITA DIGITAL DOMICILIARIA
            </h2>
          </div>

          <div className="space-y-6">
            <div className="flex items-start">
              <span className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>Yo</span>
              <TextInput
                type="text"
                name="name"
                value={`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
                onChange={handleInputChange}
                className={`flex-1 mx-2 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                disabled
              />
              <span className={`ml-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                , autorizo se lleve a cabo la visita digital domiciliaria
              </span>
            </div>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              en mi vivienda particular, así como la toma de fotografías tanto al
              interior como al exterior, por personal de la empresa SKA TRACKING
              AND SECURITY S.A. DE C.V. previa identificación de los mismos,
              visita domiciliaria, consisten en: entrevista al evaluado, vecinos
              y/o familiares, así como el llenado de los formatos los cuales serán
              proporcionados por el personal que realiza la visita.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. DE
              C.V. para que proporcione toda la información y documentación que
              derive de las evaluaciones de pruebas de confianza que me realicen.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              En este acto autorizo y conozco el aviso de privacidad el cual se
              encuentra publicado en
              https://skyangel.com.mx/avisodeprivacidad.html, por lo cual en este
              acto consiento que SKA TRACKING AND SECURITY S.A. de C.V. podrá
              recabar mis datos personales de conformidad con los términos
              establecidos en dicho aviso.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que los datos
              proporcionados en el proceso de evaluación son verdaderos.
            </p>

            <div className={`mt-12 text-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <p className="mb-8 font-bold">ATENTAMENTE</p>
              <div className={`w-64 mx-auto border-t-2 ${isDarkMode ? "border-gray-400" : "border-gray-800"} pt-2`}>
                <p className="text-sm">NOMBRE Y FIRMA</p>
              </div>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="mt-4 mb-4 px-4">
          <div className="flex justify-between">
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(-1);
              }}
              className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : "bg-red-500 hover:bg-red-600 text-white"}`}
            >
              Regresar
            </Button>
            <Button color="blue"
              className={`z-10 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700" : ""}`}
              onClick={handlePrint}
            >
              Imprimir
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
          <p className="text-sm text-white px-4">
            <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
            su reproducción, copia o sacar este documento de las Instalaciones de
            Skyangel
          </p>
        </div>

        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <div className="max-w-4xl mx-auto bg-white rounded-lg overflow-hidden mt-4 relative">
            {/* Header */}
            <HeaderPrint titulo={tituloFormulario} />
            {/* Título del formulario */}
            <div
              id="headerContent"
              className="text-center transform transition-all duration-1000 ease-out"
            >
              <h1
                className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
                style={{
                  backgroundImage: `url(${fotoMapa})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {tituloFormulario}
              </h1>
            </div>

            {/* Contenido del formulario */}
            <div className="p-2">
              <div className="text-center mb-2">
                <div className="flex justify-left items-center gap-2">
                  <p className="mt-3">Ciudad de México a</p>
                  <Controller
                    name="fecha_autorizacionvd"
                    control={control}
                    defaultValue={
                      queryFecha.data?.[0]?.fecha_autorizacionvd || ""
                    }
                    render={({ field }) => (
                      <TextInput
                        id="fecha_autorizacionvd"
                        type="date"
                        value={field.value}
                        disabled
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                        className="text-center w-25"
                      />
                    )}
                  />
                </div>
                <h2 className="text-xl font-bold mb-4">
                  AUTORIZACIÓN AL PROCESO DE VISITA DIGITAL DOMICILIARIA
                </h2>
              </div>

              <div className="space-y-6">
                <div className="flex items-start">
                  <span className="mr-2">Yo</span>
                  <TextInput
                    type="text"
                    name="name"
                    value={`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                    } ${queryEvaluado.data?.apellido_materno || ""}`}
                    onChange={handleInputChange}
                    className="flex-1 mx-2"
                  />
                  <span className={`ml-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                    , autorizo se lleve a cabo la visita digital domiciliaria
                  </span>
                </div>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                  en mi vivienda particular, así como la toma de fotografías tanto
                  al interior como al exterior, por personal de la empresa SKA
                  TRACKING AND SECURITY S.A. DE C.V. previa identificación de los
                  mismos, visita domiciliaria, consisten en: entrevista al
                  evaluado, vecinos y/o familiares, así como el llenado de los
                  formatos los cuales serán proporcionados por el personal que
                  realiza la visita.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                  Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A.
                  DE C.V. para que proporcione toda la información y documentación
                  que derive de las evaluaciones de pruebas de confianza que me
                  realicen.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                  En este acto autorizo y conozco el aviso de privacidad el cual
                  se encuentra publicado en
                  https://skyangel.com.mx/avisodeprivacidad.html, por lo cual en
                  este acto consiento que SKA TRACKING AND SECURITY S.A. de C.V.
                  podrá recabar mis datos personales de conformidad con los
                  términos establecidos en dicho aviso.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                  Bajo protesta de decir verdad hago constar que los datos
                  proporcionados en el proceso de evaluación son verdaderos.
                </p>

                <div className="mt-12 text-center">
                  <p className="mb-8 font-bold">ATENTAMENTE</p>
                  <div className="w-64 mx-auto border-t border-black pt-2">
                    <p className="text-sm">NOMBRE Y FIRMA</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <img src={FooterAutorizacionVD} alt="FooterAutorizacionVD" />
          </div>
        </div>
      </div>

    </div>
  );
};
